import ServiceShiftUI from "serviceshift-ui";
import { mask } from "vue-the-mask";
import { createApp } from "vue";
import SlideOut from 'vue3-slider';
import { reportRumError } from "@/lib/datadog";
import { getProperty, isFalsy } from "@/lib/helpers.js";
import * as mixins from "@/mixins";
import * as membershipMixins from "@/mixins/membership.js";
import * as pathHelperMixins from "@/mixins/path_helpers.js";
import store from "@/vuex/store";
import router from "@/router";
import VueSafeTeleport from 'vue-safe-teleport';

export const AppMixins = {
  ...mixins,
  ...membershipMixins,
  ...pathHelperMixins,
  getProperty,
  isFalsy
};

export const bootstrapApp = (render, props = {}) => {
  const App = createApp({
    store,
    render,
  }, props);
  App.use(router);
  App.use(store);
  App.use(ServiceShiftUI);
  App.use(SlideOut);
  App.use(VueSafeTeleport);
  App.directive("mask", mask);
  App.mixin({
    methods: AppMixins
  });
  // Observability (TOF-617): route Vue render/lifecycle errors to a structured,
  // attributable RUM error. Without this they surface only as coarse, merged
  // console buckets, so we can't tell which component/phase threw — and a throw
  // during a patch/teardown flush can silently strand a teleported overlay.
  // PII-safe: component name, lifecycle phase, path, and code error message only.
  App.config.errorHandler = (err, instance, info) => {
    try {
      reportRumError("vue.render_error", {
        component:
          instance?.$options?.__name || instance?.$options?.name || "unknown",
        phase: info,
        view_path: window.location?.pathname,
        message: err instanceof Error ? err.message : String(err)
      });
    } catch {
      // never let instrumentation break the app
    }
    // Preserve default logging (dev visibility + existing RUM console capture).
    // eslint-disable-next-line no-console
    console.error(err);
  };
  return App;
}
